import {
  actions,
  createNewPolicyAsync,
  deletePolicyAsync,
  editPolicyAsync,
  getAllPoliciesAsync,
  getPolicyByIdAsync,
  getPoliciesByTypeAsync,
  createPolicyMultilingualAsync,
  editPolicyMultilingualAsync,
  getPolicyByIdMultilingualAsync,
} from './slices';

export const PoliciesActions = {
  ...actions,
  getAllPoliciesAsync,
  getPolicyByIdAsync,
  createNewPolicyAsync,
  editPolicyAsync,
  deletePolicyAsync,
  getPoliciesByTypeAsync,
  createPolicyMultilingualAsync,
  editPolicyMultilingualAsync,
  getPolicyByIdMultilingualAsync,
};

export * from './thunkHandlers';
